import React, { useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { PSButton } from '@/components/ui/button';
import { useOnClickOutside } from '@/hooks/useOutsideClick';

const InformationModal = ({
  btnTitle,
  modalTitle,
  content,
  youtube,
}: {
  btnTitle: string;
  modalTitle: string;
  content?: string[];
  youtube?: { enUrl: string; frUrl: string };
}) => {
  const { t, i18n } = useTranslation();
  const [show, setShow] = useState(false);

  const ref = useRef(null);

  useOnClickOutside(ref, () => {
    setShow(false);
  });

  return (
    <React.Fragment>
      <div className="md:tw-flex tw-inline-flex tw-items-center tw-gap-3 md:tw-w-max">
        <PSButton
          id="btn-show-information"
          type="button"
          variant="primary"
          title={btnTitle}
          onClick={() => {
            setShow(true);
          }}
        />
      </div>

      <Modal size="lg" show={show} onHide={() => setShow(false)} backdrop="static" centered style={{ maxWidth: '100%' }}>
        <Modal.Body ref={ref}>
          <div className="tw-flex tw-flex-col tw-w-full">
            <div className="tw-w-full tw-flex tw-justify-between tw-items-center">
              <span className="tw-text-zinc-900 tw-text-xl tw-font-bold tw-font-['Sofia Sans'] tw-items-start tw-justify-between">{modalTitle}</span>
              <button
                id="btn-close-modal"
                className="btn-close"
                onClick={() => {
                  setShow(false);
                }}
              ></button>
            </div>
            <div className="tw-flex tw-flex-col gap-2 tw-mt-5">
              {content &&
                content.map((text, index) => (
                  <p key={index} className="tw-text-gray-900 tw-text-base tw-font-normal tw-font-['Lexend'] tw-leading-tight">
                    {text}
                  </p>
                ))}

              {youtube && (
                <iframe
                  src={i18n.language === 'en' ? youtube.enUrl : youtube.frUrl}
                  width="100%"
                  className="md:tw-h-[28rem] sm:tw-h-full"
                  style={{ border: 'none' }}
                  title="Tutorial Iframe"
                ></iframe>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default InformationModal;
